import momentTZ from 'moment-timezone'
import moment from 'jalali-moment'

export const func = {
  fixNumbers: str => {
    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
    if (typeof str === 'string') {
      for (let i = 0; i < 10; i++) {
        // eslint-disable-next-line no-param-reassign
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i)
      }
    }
    return str
  },
  unixToPersianDate(unixtime) {
    return moment(unixtime * 1000)
        .locale('fa')
        .format('YYYY/MM/DD  H:mm')
  },
  unixToPersianDateS(unixtime) {
    return moment(unixtime * 1000)
        .locale('fa')
        .format('YYYY/MM/DD')
  },
  unixToPersianTime(unixtime) {
    return moment(unixtime * 1000)
        .locale('fa')
        .format('H:mm')
  },
  time() {
    const now = momentTZ.tz(new Date(), 'Asia/Tehran')
    return Math.ceil(now / 1000)
  },
  todayTimes() {
    const start = new Date(this.time() * 1000)
    start.setHours(0, 0, 0, 0)

    const end = new Date()
    end.setHours(23, 59, 59, 0)

    return {
      start: start / 1000,
      end: end / 1000,
    }
  },
}

export class functions {
}
